import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

import VoiceValidationSearchForm from 'components/LM/Voice/ValidationSearch/VoiceValidationSearchForm';
import ValidationQueueDrawer from 'components/LM/Voice/ValidationSearch/ValidationQueueDrawer';

import Breadcrumb from 'components/LM/common/Breadcrumb';
import 'components/LM/Voice/Search/voiceSearch.scss';

function VoiceValidationSearch(props) {
	const { searchParams } = props;
	const [drawerOpen, setDrawerOpen] = useState(false);

	useEffect(() => {
		const hasAnyParam = Boolean(
			searchParams.term ||
			searchParams.type ||
			searchParams.channel ||
			searchParams.country ||
			searchParams.status ||
			searchParams.labels ||
			searchParams.validated ||
			searchParams.upload_csv_file_id ||
			searchParams.last_edited_by ||
			searchParams.country_confidence_min ||
			searchParams.country_confidence_max ||
			searchParams.type_confidence_min ||
			searchParams.type_confidence_max ||
			searchParams.missing_mandatory_fields ||
			searchParams.to_merge_only ||
			searchParams.has_recent_publications ||
			searchParams.has_recent_brand_mentions ||
			searchParams.voice_name_duplicates ||
			searchParams.follower_channels ||
			searchParams.followers_min ||
			searchParams.followers_max ||
			searchParams.last_edited_date_start ||
			searchParams.last_edited_date_end ||
			searchParams.voice_ids
		);
		if (hasAnyParam) {
			setDrawerOpen(true);
		}
	}, [searchParams]);

	const handleDrawerClose = () => {
		setDrawerOpen(false);
	};

	return (
		<>
			<ValidationQueueDrawer
				open={drawerOpen}
				searchParams={searchParams}
				onClose={handleDrawerClose}
			/>
			<div id="voice_search">
				<Breadcrumb items={['Voices', 'Validation', 'Search']} />
				<Card>
					<Card.Header>
						<VoiceValidationSearchForm
							searchParams={searchParams}
						/>
					</Card.Header>
				</Card>
			</div>
		</>
	);
}

VoiceValidationSearch.propTypes = {
	searchParams: PropTypes.object,
}

export default VoiceValidationSearch;
